<template>
  <div class="error-display">
    <div class="primary-message">{{ errorMessage.title }}</div>
    <div class="secondary-message">{{ errorMessage.description }}</div>
  </div>
</template>

<script>
import { ERROR_REASONS } from '@/configs/constants'

export default {
  name: 'ErrorDisplay',
  props: {
    error: { required: true }
  },
  computed: {
    errorMessage () {
      if (this.error.reason === ERROR_REASONS.INVALID_COUNTRY) {
        return {
          title: this.$t('SEARCH.ERROR.INVALID_NETWORK.TITLE'),
          description: this.$t('SEARCH.ERROR.INVALID_NETWORK.DESCRIPTION')
        }
      } else if (this.error.status === 404) {
        return {
          title: this.$t('SEARCH.ERROR.404.TITLE'),
          description: this.$t('SEARCH.ERROR.404.DESCRIPTION')
        }
      } else if (this.error.status >= 400 && this.error.status < 500) {
        return {
          title: this.$t('SEARCH.ERROR.4XX.TITLE'),
          description: this.$t('SEARCH.ERROR.4XX.DESCRIPTION')
        }
      } else {
        return {
          title: this.$t('SEARCH.ERROR.5XX.TITLE'),
          description: this.$t('SEARCH.ERROR.5XX.DESCRIPTION')
        }
      }
    }
  }
}
</script>
